import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    },
    stats: {
      display: 'grid',
      gridTemplateColumns: 'auto auto auto auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
        "type status created updated"
      `,
      // gridTemplateAreas: `
      //   "type created"
      //   "status updated"
      // `,
      gap: theme.spacing(1, 2),
      // alignItems: 'center',
      padding: 1,

      '& > .type': {
        gridArea: 'type',
      },
      '& > .status': {
        gridArea: 'status',
      },
      '& > .created': {
        gridArea: 'created',
      },
      '& > .updated': {
        gridArea: 'updated',
      },
    },
    statusValue: {
      lineHeight: '1.5em',
      display: 'flex',
      gap: 0.5,
      alignItems: 'center',
    },
  };
};
